import classnames from 'classnames';
import React from 'react';

import CSS from './PaymentMethodsGrid.module.scss';
import { paymentMethods } from './constants';

interface PaymentMethodsGridProps {
  showAll?: boolean;
  className?: string;
}

function PaymentMethodsGrid({
  showAll = true,
  className,
}: PaymentMethodsGridProps) {
  const methods = showAll
    ? paymentMethods
    : paymentMethods.filter((m) => !m.optional);

  return (
    <div className={classnames(CSS.PaymentMethodsGrid, className)}>
      <div className={CSS.Grid}>
        {methods.map((method) => {
          const Icon = method.icon;
          return (
            <div
              key={method.name}
              className={CSS.Item}
              aria-label={method.name}
            >
              <Icon />
            </div>
          );
        })}
      </div>
      <span className={CSS.Disclaimer}>Availability varies by destination</span>
    </div>
  );
}

export default PaymentMethodsGrid;
